/**
 * Global host for live XP feedback — mounted once in `app/_layout.tsx` beside
 * `<CelebrationHost/>`. It (1) keeps the header XP summary live off the coin balance
 * via useXpLiveSync, and (2) renders a "+X XP" flash for every non-level-up gain.
 * `key` remounts the flash per gain so each replays its full timeline.
 *
 * A blocking overlay (e.g. the challenge SuccessModal) covers this host, so the flash
 * waits it out rather than burning its ~2s timeline unseen — the gain is held, not
 * dropped, and plays in full once the overlay closes.
 */

import React from 'react';
import { useIsBlockedByOverlay } from '../../../shared/stores/overlayStore';
import { useXpLiveSync } from '../../hooks/useXpLiveSync';
import { useXpForegroundRefresh } from '../../hooks/useXpForegroundRefresh';
import { useXpGain } from '../../hooks/useXpGain';
import { XpGainFlash } from '../XpGainFlash';

export const XpGainHost: React.FC = () => {
  useXpLiveSync();
  useXpForegroundRefresh();
  const { gain, clear } = useXpGain();
  const isBlocked = useIsBlockedByOverlay();

  if (!gain || isBlocked) return null;
  return <XpGainFlash key={gain.id} amount={gain.amount} onDone={clear} />;
};
